<script setup lang="ts">
import BaseButton from "./BaseButton.vue";
import BaseDialog from "./BaseDialog.vue";
import { useConfirmation } from "../composables/useConfirmation";

const confirmation = useConfirmation();
</script>

<template>
  <BaseDialog :is-open="confirmation.state.isOpen" size="small" :title="confirmation.state.title"
    :description="confirmation.state.message" @close="confirmation.resolve(false)">
    <template #actions>
      <BaseButton variant="ghost" @click="confirmation.resolve(false)">
        {{ confirmation.state.cancelText }}
      </BaseButton>
      <BaseButton @click="confirmation.resolve(true)">
        {{ confirmation.state.confirmText }}
      </BaseButton>
    </template>
  </BaseDialog>
</template>
